import React from "react";

export default function Check() {
  return (
    <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_di_1718_51362)">
        <g clip-path="url(#clip0_1718_51362)">
          <rect x="1" width="40" height="40" rx="12" fill="url(#paint0_linear_1718_51362)" />
          <g clip-path="url(#clip1_1718_51362)" filter="url(#filter1_dd_1718_51362)">
            <path d="M30 8H12C11.2044 8 10.4413 8.31607 9.87868 8.87868C9.31607 9.44129 9 10.2044 9 11V32H33V11C33 10.2044 32.6839 9.44129 32.1213 8.87868C31.5587 8.31607 30.7956 8 30 8ZM19.748 25.333C19.5623 25.5188 19.3418 25.6662 19.0991 25.7668C18.8563 25.8673 18.5962 25.9191 18.3335 25.9191C18.0708 25.9191 17.8107 25.8673 17.5679 25.7668C17.3252 25.6662 17.1047 25.5188 16.919 25.333L12.293 20.707L13.707 19.293L18.333 23.919L28.293 13.96L29.707 15.374L19.748 25.333Z" fill="url(#paint1_linear_1718_51362)" />
          </g>
        </g>
      </g>
      <defs>
        <filter id="filter0_di_1718_51362" x="0.5" y="0" width="41" height="41" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1718_51362" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1718_51362" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1718_51362" />
        </filter>
        <filter id="filter1_dd_1718_51362" x="-21" y="-18.1015" width="84" height="84" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1718_51362" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="3.89851" />
          <feGaussianBlur stdDeviation="15" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_1718_51362" result="effect2_dropShadow_1718_51362" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1718_51362" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_1718_51362" x1="21" y1="0" x2="21" y2="40" gradientUnits="userSpaceOnUse">
          <stop stop-color="#29282C" />
          <stop offset="1" stop-color="#100F11" />
        </linearGradient>
        <linearGradient id="paint1_linear_1718_51362" x1="8.81456" y1="3.06879" x2="26.2368" y2="28.6055" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0.65" />
        </linearGradient>
        <clipPath id="clip0_1718_51362">
          <rect x="1" width="40" height="40" rx="12" fill="white" />
        </clipPath>
        <clipPath id="clip1_1718_51362">
          <rect width="24" height="24" fill="white" transform="translate(9 8)" />
        </clipPath>
      </defs>
    </svg>
  )
}